import definitions from "../../../definitions";
import Tilemap from "../../Tilemap";
import EnemyButterfly from "./EnemyButterfly";
import EnemyChicken from "./EnemyChicken";
import EnemyDuckling from "./EnemyDuckling";
import EnemyFirefly from "./EnemyFirefly";
import EnemySimonSays from "./EnemySimonSays";
import EnemySnake from "./EnemySnake";
import EnemySnapperPlant from "./EnemySnapperPlant";
import EnemySpider from "./EnemySpider";
import EnemySpikeTrap from "./EnemySpikeTrap";

export default class EnemyFactory {
    /**
     * @param {string} id
     * @param {object} [properties={}]
     * @returns {Enemy}
     */
    static create(id, properties = {}) {
        switch (id) {
            case definitions.ENEMY_ID.BUTTERFLY: {
                return new EnemyButterfly();
            }
            case definitions.ENEMY_ID.CHICKEN: {
                return new EnemyChicken();
            }
            case definitions.ENEMY_ID.DUCKLING: {
                return new EnemyDuckling();
            }
            case definitions.ENEMY_ID.FLYING_SNAKE: {
                return new EnemySnake();
            }
            case definitions.ENEMY_ID.FIREFLY: {
                return new EnemyFirefly();
            }
            case definitions.ENEMY_ID.SIMON_SAYS: {
                return new EnemySimonSays();
            }
            case definitions.ENEMY_ID.SNAPPER_PLANT: {
                return new EnemySnapperPlant();
            }
            case definitions.ENEMY_ID.SPIDER: {
                return new EnemySpider();
            }
            case definitions.ENEMY_ID.SPIKE_TRAP: {
                const trap = new EnemySpikeTrap();
                trap.attackDelay = Tilemap.getCustomProperty("attackDelay", properties);
                trap.attackOffset = Tilemap.getCustomProperty("attackOffset", properties);
                return trap;
            }
        }
        return null;
    }
}